/* eslint-disable no-param-reassign */
import IdentityProvidersApi from 'client/api/v2/IdentityProvidersApi';
import ModelMixin from 'client/store/modules/models/mixins/ModelMixin';
import Vue from 'vue';
import createModel from 'client/store/modules/models/createModel';

export const getDefaultItem = () => ({
  name: '',
  objectId: '',
  oidc: {
    clientId: '',
    clientSecret: '',
    url: '',
  },
  type: 'OIDC',
});

export const getDefaultState = () => ({
  item: getDefaultItem(),
  previousItem: getDefaultItem(),
  totalCount: 0,
});

const model = createModel(getDefaultItem, 'objectId', IdentityProvidersApi);

export default {
  namespaced: true,

  state: {
    ...model.state,
    ...getDefaultState(),
  },

  actions: {
    ...model.actions,
    ...ModelMixin.actions,

    setOidc({ commit }, oidc) {
      commit('SET_OIDC', oidc);
    },
  },

  getters: {
    ...model.getters,
    ...ModelMixin.getters,
  },

  mutations: {
    ...model.mutations,
    ...ModelMixin.mutations,

    /**
     * Note that Vue.set() is used here in case the key doesn't yet exist in
     * the default state!
     */
    SET_OIDC(state = { item: {} }, item = {}) {
      // TODO: Is there a better way to set deep rooted properties?
      Object.keys(item).forEach(key => Vue.set(state.item.oidc, key, item[key]));
    },
  },
};
